module.exports = __webpack_public_path__ + "static/apple-cinnamon-20916aa5f72cb79ee536a6aa26eafc07.png";